import logo from 'assets/logo-iso.png'
import { makeStyles } from '@material-ui/styles'
import { Theme } from 'styling/theme'

export default makeStyles((theme: Theme) => ({
    title: {
        ...theme.typographyPresets.titleMedium,
        fontStyle: 'normal',
    },
    root: {
        padding: '16px',
        width: '320px',
        height: '100%',
        overflowX: 'hidden',
    },
    logo: {
        width: '320px',
        height: '150px',
        backgroundImage: `url(${logo})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'bottom',
        transform: 'scale(1.6)',
    },
    subtitle: {
        cursor: 'pointer',
        fontFamily: 'NotoSans',
        fontSize: '14px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '1.71',
        letterSpacing: 'normal',
        color: theme.colors.text.dark,
        textDecoration: 'underline',
        marginBottom: '60px',
    },
    message: {
        ...theme.typographyPresets.bodySecondary,
        margin: ' 16px 0 32px 0',
        textAlign: 'center',
        width: '100%',
    },
    error: {
        color: '#d00',
        fontWeight: 'bold',
        textShadow: '1px 1px #fdd',
        fontSize: '16px',
    },
    signupBtn: {
        margin: '45px 0',
    },
}))
